/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { IMeResponse } from '@src/services/authentication/getMe';
import { queryClient } from '@src/components/QueryClient';

export const useGetMe = () => queryClient.getQueryData<IMeResponse['data']>('me');
